import React from 'react';
import PropTypes from 'prop-types';
import { isEmptyString } from 'utils/text';
import css from './HelpResources.scss';
import Icon from 'SF/MaterialIcon';

/**
 * @returns {JSX.Element|null} the help desk website, if present
 */
function HelpWebsite({ supportWebsiteDisplayText, url }) {
    if (isEmptyString(url)) return null;
    return (
        <div className={css['helpdesk-item']}>
            <div className={css['helpdesk-icon']}>
                <Icon icon="dvr" aria-hidden="true" />
            </div>
            <div className={css['helpdesk-element']}>
                <a href={url} aria-label="Visit institutions support website. This link will open a new tab">
                    {supportWebsiteDisplayText || 'Support Website'}
                </a>
                <span>This link will open a new tab</span>
            </div>
        </div>
    )
}

HelpWebsite.propTypes = {
    supportWebsiteDisplayText: PropTypes.string,
    url: PropTypes.string
};

export default HelpWebsite;
